/* Lavender Farm Simulator — QA tools (admin QA session only).
   A "🧪 QA tools" button (bottom left) opens a panel to:
     • set the farm date (year, season, week, day, time) or jump to planting windows, bloom, frost and winter
     • plant a full field, water, grow, bring into bloom, refill energy
     • fire every special effect on demand (splash, sprout, harvest, weekly report, Almanac card, growth, 3D view…)
   Everything writes only to the QA save (the admin QA session already keeps it separate from the live farm).
   Players never see this: it only runs while the Admin QA session is active. */
(function () {
  'use strict';
  if (window.GLLFQA) return;
  var qa = false;
  try { qa = !!sessionStorage.getItem('gllfAdminModeV65'); } catch (e) {}
  if (!qa) { window.GLLFQA = { off: true }; return; }

  var SEASONS = ['Spring', 'Summer', 'Fall', 'Winter'], DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  var COLORS = { 'purple-blue': '#6a5acd', 'blue': '#6f7fd0', 'violet': '#7b5aa6', 'purple': '#7b5aa6', 'dark purple': '#5b3a8c', 'deep purple': '#5b3a8c', 'pink': '#d88fb8', 'white': '#efeaf3', 'lavender': '#9a79d1' };
  function root() { return document.getElementById('lfg-simulator-root'); }
  function A() { var r = root(); return r && r._lfg; }
  function st() { try { return A().state(); } catch (e) { return null; } }
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function commit(msg) {
    var a = A(); if (!a) return;
    try { a.save(); } catch (e) {}
    try { a.render(); } catch (e) {}
    try { root().dispatchEvent(new CustomEvent('lfg:render')); } catch (e) {}
    if (window.GLLFLoop) try { window.GLLFLoop.refresh(); } catch (e) {}
    note(msg); refresh();
  }
  function dayOfYear(m, d) { return [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31].slice(0, m - 1).reduce(function (a, b) { return a + b; }, 0) + d - 1; }
  /* the game year runs from Mar 20 (spring equinox): Spring weeks 1-13, Summer, Fall, Winter */
  function partsFor(m, d) {
    var off = (dayOfYear(m, d) - dayOfYear(3, 20) + 365) % 365, wi = Math.min(51, Math.floor(off / 7));
    return { season: Math.floor(wi / 13), week: wi % 13 + 1, day: Math.min(6, off - wi * 7) };
  }
  function dateText(s) {
    try { var d = root()._lfgTimeV54.calendarDate(s); return d.toLocaleDateString('en-US', { timeZone: 'UTC', month: 'long', day: 'numeric', year: 'numeric' }); } catch (e) { return ''; }
  }
  function plan() { try { return root()._lfgSiteWindow.plantingPlan(); } catch (e) { return null; } }
  function setDate(p, minute) {
    var s = st(); if (!s) return;
    if (p.year) s.year = Math.max(1, Math.min(10000, Math.round(p.year)));
    s.season = p.season; s.week = p.week; s.time = s.time || {}; s.time.day = p.day || 0;
    if (minute != null) s.time.minute = minute;
    s.time.forecastKey = '';   /* fetch that week's weather */
    commit('Farm date set to ' + SEASONS[s.season] + ' Week ' + s.week + ', ' + DAYS[s.time.day] + ' (' + dateText(s) + ').');
  }
  function jump(which) {
    var pl = plan(), m = 0, d = 0, min = 480;
    function mmdd(x) { var a = String(x || '').split('-').map(Number); return a.length === 2 && a[0] ? a : null; }
    if (which === 'spring') { var t = pl && pl.springText ? pl.springText.split('–')[0] : 'Apr 20'; var dt = new Date(t + ' 2024'); m = dt.getMonth() + 1; d = dt.getDate() + 5; }
    else if (which === 'fall') { var f = pl && /\w{3} \d+/.test(pl.fallText) ? pl.fallText.split('–')[0] : 'Aug 18'; var df = new Date(f + ' 2024'); m = df.getMonth() + 1; d = df.getDate() + 5; }
    else if (which === 'bloom') { m = 6; d = 28; }
    else if (which === 'harvest') { m = 7; d = 12; }
    else if (which === 'frost') { var ff = mmdd(pl && pl.firstDate) || [10, 15]; m = ff[0]; d = ff[1]; min = 360; }
    else if (which === 'winter') { m = 1; d = 20; }
    else if (which === 'night') { var s0 = st(); if (s0) { s0.time.minute = 22 * 60; commit('Set to 10:00 PM.'); } return; }
    else if (which === 'noon') { var s1 = st(); if (s1) { s1.time.minute = 12 * 60; commit('Set to noon.'); } return; }
    if (d > 28) { d -= 28; m++; }
    var p = partsFor(m, d); setDate(p, min);
  }

  function cultivar(s) {
    var list = (A().data && A().data.cultivars) || [];
    return list.filter(function (c) { return c.id === s.crop; })[0] || list.filter(function (c) { return /angustifolia/i.test(c.group || '') && c.fieldPlantable !== false; })[0] || list[0];
  }
  function newPlant(c, stage) {
    var r = root(), p = { id: c.id, name: c.name, stage: stage || 1, age: 0, moist: 70, health: 92, color: COLORS[String(c.color || '').toLowerCase()] || '#7b5aa6', pollinator: false };
    try { p = (r._lfgSeasonalV38 && r._lfgSeasonalV38.createPlant(p, c, 'field')) || p; } catch (e) {}
    return p;
  }
  function eachPlant(fn) { var s = st(); if (!s || !Array.isArray(s.plants)) return 0; var n = 0; s.plants.forEach(function (p, i) { if (p) { fn(p, i); n++; } }); return n; }
  var ACTIONS = {
    plantAll: function () { var s = st(), c = cultivar(s), n = 0, max = Math.min(s.plants.length, +s.plots || s.plants.length); for (var i = 0; i < max; i++) if (!s.plants[i]) { s.plants[i] = newPlant(c, 1); n++; } commit('Planted ' + n + ' plots with ' + c.name + '.'); },
    water: function () { var n = eachPlant(function (p) { p.moist = 85; }); commit('Watered ' + n + ' plants.'); },
    grow: function () { var y = +(st() || {}).year || 1; var n = eachPlant(function (p) { p.stage = Math.min(5, (+p.stage || 1) + 1); p.age = (+p.age || 0) + 4; if (p.stage >= 3) (p.perennialV82 = p.perennialV82 || {}).establishedYear = Math.min(+p.perennialV82.establishedYear || y, y - 1); }); commit('Grew ' + n + ' plants by one stage.'); },
    bloom: function () { var n = eachPlant(function (p) { p.stage = 5; p.dormant = false; p.phenology = p.phenology || {}; p.phenology.bloomStage = 3; p.phenology.phase = 'blooming'; }); commit(n + ' plants in full bloom.'); },
    heal: function () { var n = eachPlant(function (p) { p.health = 100; p.moist = 75; }); commit('Healed ' + n + ' plants.'); },
    clear: function () { var s = st(), n = 0; s.plants = s.plants.map(function (p) { if (p) n++; return null; }); commit('Cleared ' + n + ' plots.'); },
    advance: function (n) {
      var r = root(), a = A(), left = n || 1, done = 0; if (!a || !a.advance || ACTIONS._busy) return; ACTIONS._busy = true;
      note('Advancing ' + left + ' week' + (left > 1 ? 's' : '') + '…');
      (function step() {
        var s = st(); if (s && s.life && s.life.needs) s.life.needs.energy = 100;
        try { a.advance(); } catch (e) { ACTIONS._busy = false; return note('Advance stopped: ' + e.message); }
        done++;
        setTimeout(function () {
          if (left > 1) { document.querySelectorAll('.gjx-report').forEach(function (x) { x.remove(); }); }
          if (done < left) return step();
          ACTIONS._busy = false; var s2 = st(), alive = s2 ? s2.plants.filter(Boolean).length : 0;
          note('Advanced ' + done + ' week' + (done > 1 ? 's' : '') + '. ' + alive + ' plants in the field.'); refresh();
        }, 1600);
      })();
    },
    energy: function () { var s = st(); s.life = s.life || {}; s.life.needs = s.life.needs || {}; s.life.needs.energy = 100; commit('Energy refilled to 100.'); }
  };
  function fieldPlot() { var r = root(); return r && (r.querySelector('#lfg-field [data-plot].gllf-has-plant') || r.querySelector('#lfg-field [data-plot]')); }
  var EFFECTS = {
    water: function () { fx('water'); }, plant: function () { fx('plant'); }, harvest: function () { fx('harvest'); }, inspect: function () { fx('inspect'); }, clear: function () { fx('clear'); },
    report: function () { if (window.GLLFJuice) { try { localStorage.removeItem('gllfWeekReportOff'); } catch (e) {} window.GLLFJuice.report(); } },
    card: function () { var a = window.GLLFAlmanac; if (a && a.teach) { var c = (a.cards || [])[Math.floor(Math.random() * ((a.cards || []).length || 1))]; if (c) a.teach(c); } else note('Almanac not loaded.'); },
    grow: function () { ACTIONS.grow(); },
    unlock: function () { var r = root(); if (window.GLLFLoop) note('Unlock cards appear when a new area opens (level up in Player State).'); },
    view3d: function () { if (window.GLLF3D) { close(); window.GLLF3D.open(); } }
  };
  function fx(k) {
    var r = root(), p = fieldPlot(); if (!p || !r.querySelector('#lfg-view-field.active')) { note('Open the Lavender Field first, then try again.'); return; }
    var i = +p.getAttribute('data-plot') || 0; p.scrollIntoView({ block: 'center', behavior: 'smooth' });
    setTimeout(function () { if (window.GLLFJuice) window.GLLFJuice.fx(k, i); }, 350);
  }

  /* ---------- panel ---------- */
  var btn = null, panel = null, msgT = 0;
  function note(t) { var n = panel && panel.querySelector('[data-qa-note]'); if (n) { n.textContent = t; n.hidden = false; clearTimeout(msgT); msgT = setTimeout(function () { n.hidden = true; }, 6000); } }
  function refresh() {
    if (!panel) return; var s = st(); if (!s) return;
    var pl = plan();
    panel.querySelector('[data-qa-now]').innerHTML = '<b>' + esc(SEASONS[+s.season || 0] + ' Week ' + (s.week || 1) + ' · ' + DAYS[(s.time && s.time.day) || 0] + ' · Year ' + s.year) + '</b><span>' + esc(dateText(s)) + '</span>' +
      (pl ? '<span>Outdoor planting: <b>' + (pl.open ? 'OPEN' : 'closed') + '</b> · Spring ' + esc(pl.springText) + ' · Fall ' + esc(pl.fallText) + '</span>' : '');
    panel.querySelector('[name="year"]').value = s.year || 1;
    panel.querySelector('[name="season"]').value = +s.season || 0;
    panel.querySelector('[name="week"]').value = s.week || 1;
    panel.querySelector('[name="day"]').value = (s.time && s.time.day) || 0;
    panel.querySelector('[name="hour"]').value = Math.floor(((s.time && s.time.minute) || 480) / 60);
  }
  function open() {
    if (panel) return refresh();
    panel = document.createElement('div'); panel.className = 'gqa'; panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-label', 'QA tools');
    var opt = function (arr) { return arr.map(function (t, i) { return '<option value="' + i + '">' + t + '</option>'; }).join(''); };
    var hours = []; for (var h = 0; h < 24; h++) hours.push((h % 12 || 12) + ':00 ' + (h < 12 ? 'AM' : 'PM'));
    var weeks = []; for (var w = 1; w <= 13; w++) weeks.push('Week ' + w);
    panel.innerHTML =
      '<div class="gqa__head"><b>🧪 QA tools</b><small>QA save only</small><button type="button" data-qa="close" aria-label="Close">✕</button></div>' +
      '<div class="gqa__now" data-qa-now></div>' +
      '<h4>Farm date</h4><div class="gqa__row">' +
        '<label>Year<input name="year" type="number" min="1" max="10000"></label>' +
        '<label>Season<select name="season">' + opt(SEASONS) + '</select></label>' +
        '<label>Week<select name="week">' + weeks.map(function (t, i) { return '<option value="' + (i + 1) + '">' + t + '</option>'; }).join('') + '</select></label>' +
        '<label>Day<select name="day">' + opt(DAYS) + '</select></label>' +
        '<label>Time<select name="hour">' + opt(hours) + '</select></label>' +
      '</div><button type="button" class="gqa__main" data-qa="set">Set farm date</button>' +
      '<div class="gqa__grid">' +
        '<button type="button" data-qj="spring">🌱 Spring planting</button><button type="button" data-qj="fall">🍂 Fall planting</button>' +
        '<button type="button" data-qj="bloom">🪻 Bloom</button><button type="button" data-qj="harvest">✂️ Harvest time</button>' +
        '<button type="button" data-qj="frost">❄️ First frost</button><button type="button" data-qj="winter">☃️ Mid-winter</button>' +
        '<button type="button" data-qj="noon">☀️ Noon</button><button type="button" data-qj="night">🌙 Night</button>' +
      '</div>' +
      '<h4>Field</h4><div class="gqa__grid">' +
        '<button type="button" data-qa-act="plantAll">🌱 Plant every empty plot</button><button type="button" data-qa-act="water">💧 Water all</button>' +
        '<button type="button" data-qa-act="grow">⬆️ Grow one stage</button><button type="button" data-qa-act="bloom">🪻 Full bloom</button>' +
        '<button type="button" data-qa-act="heal">✨ Heal all</button><button type="button" data-qa-act="energy">⚡ Refill energy</button>' +
        '<button type="button" data-qa-act="clear">🧤 Clear field</button><button type="button" data-qa-adv="1">⏩ Advance 1 week</button><button type="button" data-qa-adv="4">⏩ Advance 4 weeks</button><button type="button" data-qa-adv="13">⏩ Advance a season</button>' +
      '</div>' +
      '<h4>Special effects</h4><div class="gqa__grid">' +
        '<button type="button" data-qa-fx="water">💦 Watering splash</button><button type="button" data-qa-fx="plant">🌱 Sprout pop</button>' +
        '<button type="button" data-qa-fx="harvest">💐 Harvest bundle</button><button type="button" data-qa-fx="inspect">🔍 Inspect ping</button>' +
        '<button type="button" data-qa-fx="clear">💨 Clear puff</button><button type="button" data-qa-fx="grow">🌾 Growth moment</button>' +
        '<button type="button" data-qa-fx="report">📰 Weekly report</button><button type="button" data-qa-fx="card">📖 Almanac card</button>' +
        '<button type="button" data-qa-fx="view3d">🧊 3D farm</button>' +
      '</div>' +
      '<p class="gqa__note" data-qa-note role="status" hidden></p>';
    document.body.appendChild(panel);
    panel.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      if (b.getAttribute('data-qa') === 'close') return close();
      if (b.getAttribute('data-qa') === 'set') {
        var v = function (n) { return +panel.querySelector('[name="' + n + '"]').value; };
        return setDate({ year: v('year'), season: v('season'), week: v('week'), day: v('day') }, v('hour') * 60);
      }
      if (b.hasAttribute('data-qj')) return jump(b.getAttribute('data-qj'));
      if (b.hasAttribute('data-qa-adv')) return ACTIONS.advance(+b.getAttribute('data-qa-adv'));
      if (b.hasAttribute('data-qa-act')) return ACTIONS[b.getAttribute('data-qa-act')]();
      if (b.hasAttribute('data-qa-fx')) return EFFECTS[b.getAttribute('data-qa-fx')]();
    });
    refresh();
  }
  function close() { if (panel) { panel.remove(); panel = null; } }
  function mountButton() {
    if (btn || !root()) return;
    btn = document.createElement('button'); btn.type = 'button'; btn.className = 'gqa-launch'; btn.textContent = '🧪 QA tools';
    btn.addEventListener('click', function () { if (panel) close(); else open(); });
    document.body.appendChild(btn);
  }
  var tries = 0; (function wait() { if (root() && A()) mountButton(); else if (++tries < 60) setTimeout(wait, 1000); })();
  window.GLLFQA = { open: open, close: close, setDate: setDate, jump: jump, actions: ACTIONS, effects: EFFECTS };
})();
